const FilterIasViewabilities = [
  { id: '40, 50, 60, 70, 80, 90', name: '40+' },
  { id: '50, 60, 70, 80, 90', name: '50+' },
  { id: '60, 70, 80, 90', name: '60+' },
  { id: '70, 80, 90', name: '70+' },
  { id: '80, 90', name: '80+' },
  { id: '90', name: '90+' }
];

export default FilterIasViewabilities;



// WEBPACK FOOTER //
// ./src/views/StaticData/FilterIasViewabilities.tsx